import Footer from "../components/FooterComponent";
import NavBar from "../components/NavBar";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getMovie } from "../stores/actions/movieAction";

export default function Detail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { oneMovie, genreMovie, castMovie } = useSelector(
    (state) => state.movies
  );

  const actor = castMovie.map((el) => el.name);
  const actor2 = actor.join(", ");
  // console.log(actor2, "<><><<><>");

  useEffect(() => {
    dispatch(getMovie(id));
  }, [id]);
  return (
    <>
      <NavBar></NavBar>
      <div className="w-full bg-black max-h-max">
        <div className="container mx-auto py-10">
          <div className="border-b border-gray-900 bg-white h-full w-full">
            <iframe
              className="w-full aspect-[8/3]"
              src={oneMovie.trailerUrl}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <div className="w-full bg-stone-200 min-h-screen">
        <div className="flex justify-center py-5">
          <div className="flex flex-col md:flex-row md:max-w-7xl rounded-lg bg-stone-200 shadow-lg">
            <img
              className=" w-full h-96 md:h-auto object-cover md:w-48 rounded-t-lg md:rounded-none md:rounded-l-lg"
              src={oneMovie.imgUrl}
              alt=""
            />
            <div className="p-6 flex flex-col justify-start">
              <h5 className="text-gray-900 text-xl font-medium mb-2 text-left">
                {oneMovie.title}
              </h5>
              <h6 className="text-gray-800 text-base font-medium text-left">
                Sinopsis:
              </h6>
              <p className="text-gray-700 text-sm mb-2 text-justify">
                {oneMovie.synopsis}
              </p>
              <h6 className="text-gray-800 text-base font-medium text-left">
                Actor:
              </h6>
              <p className="text-gray-700 text-sm mb-2 text-left">
                {!actor2 ? "-" : actor2}
              </p>
              <h6 className="text-gray-800 text-base font-medium text-left">
                Genre:
              </h6>
              <p className="text-gray-700 text-sm mb-2 text-left">
                {genreMovie.name}
              </p>
              <h6 className="text-gray-800 text-base font-medium text-left">
                Rating:
              </h6>
              <p className="text-gray-700 text-sm mb-2 text-left">
                {oneMovie.rating}
              </p>
              <p className="text-gray-600 text-xs">Last updated 3 mins ago</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
